class PricePermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'price.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'price._m';

    // Access deleted prices
    static ACCESS_DELETED = 'price.access.deleted';

    // Access inactive prices
    static ACCESS_INACTIVE = 'price.access.inactive';

    // Access prices, marked as legacy
    static ACCESS_LEGACY = 'price.access.legacy';

    // Access prices without plan attached
    static ACCESS_NO_PLAN = 'price.access.no_plan';

    // Access prices, where plan visibility is internal
    static ACCESS_PLAN_VISIBILITY_INTERNAL = 'price.access.plan_visibility.internal';

    // Initiate price sync
    static SYNC = 'price.sync';

    // Manage price plan attachment
    static PLAN_MANAGE = 'price.plan.manage';
}

export default PricePermission;
